import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import SaveToResultsEditor from '../editors/custom-editors/SaveToResultsEditor';
import {StepTypeConfigUISchemaV2} from '../step-config-settings/StepConfigUISchemas';
import {CUSTOM_COMPONENT_KEY, FIELD_ORDER_UI_SCHEMA_KEY} from '../StepConfigEditorTypes';

export const SAVE_TO_RESULTS_V2_UI_SCHEMA: StepTypeConfigUISchemaV2<PipelineStepType.SAVE_TO_RESULTS, 2> = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['customEditor'],
  customEditor: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['customEditor'],
    customEditor: {
      displayName: '',
      [CUSTOM_COMPONENT_KEY]: SaveToResultsEditor,
    },
  },
};
